import {SODeleteOrganizationInvite} from '../../core/organization-invite/so-delete-organization-invite';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteOrganizationInvite extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteOrganizationInvite;
}